// Sectiunea "Bilete castigatoare premium/cod" — vizibila pentru toate conturile.

// Folosim acelasi folder din Storage in care admin-ul incarca imaginile (tab "Imagini" din /apanel).
export const PREMIUM_TICKETS_STORAGE_FOLDER = 'ticketImages';

// Sectiunea este activa implicit; se poate bloca din /apanel
// (doc Firestore appSettings/premiumTickets -> { enabled: boolean }).
export const DEFAULT_PREMIUM_TICKETS_ENABLED = true;
